// Models
import WinnersTable from '../WinnersTable/WinnersTable';

/**
 * @function Leaderboard
 * Describe the component's function
 *
 * @example
 * return (
 *   <Leaderboard title='' winners={[]} />
 * )
 */
function Leaderboard({ title, winners }: LeaderboardProps): JSX.Element {
    function getOrdinal(n: number): string {
        return ['st', 'nd', 'rd'][((((n + 90) % 100) - 10) % 10) - 1] || 'th';
    }

    return (
        <WinnersTable title={title}>
            <tbody>
                {winners.map(({ id, username, points, patterns }, index) => {
                    return (
                        index <= 9 && (
                            <tr key={id}>
                                <td>
                                    {index + 1}
                                    {getOrdinal(index + 1)}
                                </td>
                                <td>{username}</td>
                                <td>{points} PP</td>
                            </tr>
                        )
                    );
                })}
            </tbody>
        </WinnersTable>
    );
}

/**
 * @interface LeaderboardProps
 * Describes the properties required for the Leaderboard component
 *
 * @property {string} title
 * @property {array} winners
 */
export interface LeaderboardProps {
    title: string;
    winners: {
        id: number;
        username: string;
        points: number;
        patterns: number;
    }[];
}

// Exports
export default Leaderboard;
